<style scoped>
</style>

<script>
import { simpleComputed } from '@state/helpers'
import { remotePlayer } from '@utils/lidb'

export default {
	components: {},
	props: {

	},
	data() {
		return {
			media : {
				artist : '',
				title : '',
				mp3 : '',
			},

			isPlaying : false,
			playerURL : process.env.VUE_APP_PLAYER,
			eventRegistered : false,
		}
	},
	computed : {
		...simpleComputed,
	},
	created() {
		if(!this.eventRegistered) {
			this.eventRegistered = true;
			window.addEventListener("message", this.eventListener);
		}
	},
	mounted() {
	},
	updated() {
	},
	methods : {
		open(e) {
			e.stopPropagation();
			e.preventDefault();

			this.playerOpen();
		},

		eventListener(event) {
			const eventName = event.data.eventName;
			const statusInfo = event.data.statusInfo;
			
			switch(eventName) {
			case 'canplaythrough':	// user agent 가 media 를 재생할 수 있을 때 발생되며, 컨텐츠의 추가 버퍼링을 위한 정지 없이 media 를 끝까지 재생하기에 로드된 데이터가 충분할 것으로 추산한다.
				// this.media = statusInfo.media;
				this.playerPlay(statusInfo.media)
				break;
			case 'playing':
				this.isPlaying = true;
				break;
			case 'pause':
				this.isPlaying = false;
				break;
			}
		},

		remotePlayer : remotePlayer,

	}

}
</script>

<template>
	<div>
		<div class="miniplayer">
			<button v-show="!player.isOpen" type="button" class="btn btn-warning btn-sm" @click="open">플레이어 실행</button>

			<div v-show="player.isOpen" class="input-group mb-2">
				<div class="input-group-prepend">
					<div class="input-group-text">
						<a href="#none" @click="open"><i class="fe-music"></i></a>
					</div>
				</div>
				<div class="text-nowrap form-control scroll-left">
					<p>{{player.artist}} - {{player.title}}</p>
				</div>
				<div class="input-group-append">
					<div class="input-group-text">
						<a href="#none" @click.prevent="remotePlayer('remocon_prevPlay')"><i class="fa fa-step-backward fa-fw" ></i></a>
						<a href="#none" @click.prevent="remotePlayer('remocon_togglePlay')">
							<i v-show="isPlaying" class="fa fa-pause fa-fw"></i>
							<i v-show="!isPlaying" class="fa fa-play fa-fw"></i>
						</a>
						<a href="#none" @click.prevent="remotePlayer('remocon_nextPlay')"><i class="fa fa-step-forward fa-fw" ></i></a>
					</div>
				</div>
			</div>
		</div>
			<!-- <a :href="playerURL" target="_blank" rel="noopener noreferrer" class="nav-link dropdown-toggle  waves-effect waves-light btn btn-link">
				<i className="fe-music" style="font-size:21px"></i>
			</a> -->
	</div>
</template>
